import { enqueueSnackbar } from "notistack";
import { useMutation } from "react-query";
import { registerN01User } from "./gateway";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function useRegisterN01User() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (data: FormData) => registerN01User(data),
    onSuccess: (_, variables) => {
      enqueueSnackbar(t("Επιτυχής Εγγραφή"), { variant: "success" });

      navigate("/welcomeNonGemi/checkYourEmail", {
        state: { userEmail: variables.n01_email },
      });
    },
  });
}
